export const endPoints = {
  leads: {
    fetchleads: "/leads/get-leads",
    upsertLead: "/leads/auth-upsert-leads",
    statusLead: "/leads/get-status-leads",
    fetchGeneralLeads: "/leads/get-general-lead",
    bulkUploadLeads: "/leads/bulk-upload-leads",
  },
  opportunity: {
    createOpportunity: "/leads/create-opportunity",
  },
  insurer: {
    createInsurer: "/insurance/create-insurer-code",
  },
  csioCompany: {
    upsertCSIOCompany: "/insurance/create-csio-company-record",
  },
  subInusrer: {
    upsertSubInsurer: "/insurance/create-insurer-sub",
  },
  policyComission: {
    upsertPolicyComission: "/insurance/create-policy-commission",
  },
  insurerContacts: {
    upsertInsurerContacts: "/insurance/create-insurer-contacts",
  },
  underWriters: {
    upsertUnderwriters: "/insurance/create-underwriters",
  },
  brokerCodes: {
    createBrokerCode: "/insurance/create-broker-code",
  },
  brokerContacts: {
    createBorkerContact: "/insurance/create-broker-contracts",
  },
  branchOffice: {
    createBranchOffice: "/insurance/create-branch-office",
  },
  interestedParty: {
    createIntrestedParty: "/insurance/create-interested-party",
  },
  additionalIntrest: {
    createAdditionalIntrest: "/insurance/create-additional-interest",
  },
  appForms: {
    editAppForms: "/other/edit-apps-and-forms",
  },
  support: {
    upsertSupport: "/other/create-support-ticket",
  },
  legalPlus: {
    upsertLegal: "/other/upsert-legal-plus",
  },
  upsell: {
    upsellInsight: "/dashboard/upselling-insights",
    upsellTemplate: "/template/get-recommended-template",
    autoGenerateCampaign: "/campaign/auto-generate-campaign",
  },
  delivery: {
    fetchDeliveryLogs: "/autoInvoice/get-delivery-log",
  },
};
